













import { Component, Prop, Emit, Vue } from "vue-property-decorator";
import { DisplayTime } from "@/typescript/packages/timepicker/types";
export { DisplayTime };

@Component
export default class TimepickerComponent extends Vue {
  @Prop()
  timepickerWidth!: string;

  @Prop({
    default: () => ({ HH: "00", mm: "00", ss: "00" })
  })
  value!: DisplayTime;

  @Prop({
    default: false
  })
  isDisabled!: boolean;

  @Prop({
    default: 1
  })
  minuteInterval!: number;

  @Emit()
  change(value: DisplayTime) {
    return value;
  }

  get internalValue(): DisplayTime {
    return this.value;
  }

  set internalValue(value: DisplayTime) {
    this.change(value);
  }
}
